var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Waveform',{attrs:{"wave_data":_vm.now_playing.waveform,"height":"30"}}),_c('Waveform',{attrs:{"wave_data":_vm.now_playing.waveform,"height":"30","color":"#08f","progress":_vm.progress}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }